"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Airdropper__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "_settleDestination",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "addr",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "roundId",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "AddAirdrop",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "addr",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "roundId",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "AirdropClaimed",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "roundId",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "address",
                name: "tokenAddress",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "roundStartTime",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "roundDeadline",
                type: "uint256",
            },
        ],
        name: "RoundCreated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "roundId",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "address",
                name: "settleDestination",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "unclaimAmount",
                type: "uint256",
            },
        ],
        name: "RoundSettled",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "roundId",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "roundStartTime",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "roundDeadline",
                type: "uint256",
            },
        ],
        name: "RoundUpdated",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "controller",
                type: "address",
            },
        ],
        name: "addController",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "airdropRecord",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address[]",
                name: "_addr",
                type: "address[]",
            },
            {
                internalType: "uint256[]",
                name: "_roundId",
                type: "uint256[]",
            },
            {
                internalType: "uint256[]",
                name: "_amount",
                type: "uint256[]",
            },
        ],
        name: "batchAirdrop",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256[]",
                name: "_roundIds",
                type: "uint256[]",
            },
        ],
        name: "batchClaimAirdrop",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_roundId",
                type: "uint256",
            },
        ],
        name: "claimAirdrop",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "controllers",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_tokenAddr",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_roundStartTime",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_roundDeadline",
                type: "uint256",
            },
        ],
        name: "createRound",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "nextRoundId",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "controller",
                type: "address",
            },
        ],
        name: "removeController",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "roundRecord",
        outputs: [
            {
                internalType: "address",
                name: "tokenAddress",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "roundStartTime",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "roundDeadline",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "unclaimedAmount",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_settleDestination",
                type: "address",
            },
        ],
        name: "setSettleDestination",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "settleDestination",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_roundId",
                type: "uint256",
            },
        ],
        name: "settleEndedRound",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_roundId",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_roundStartTime",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_roundDeadline",
                type: "uint256",
            },
        ],
        name: "updateRound",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
class Airdropper__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
        this.contractName = "Airdropper";
    }
    deploy(_settleDestination, overrides) {
        return super.deploy(_settleDestination, overrides || {});
    }
    getDeployTransaction(_settleDestination, overrides) {
        return super.getDeployTransaction(_settleDestination, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.Airdropper__factory = Airdropper__factory;
Airdropper__factory.bytecode = _bytecode;
Airdropper__factory.abi = _abi;
